import React from 'react'
import { ExtratoConta } from '../LanctoCaixaService'
import { Funcoes } from '../../../Utils/Funcoes'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Caixa } from '../../../Utils/Types'
import moment from 'moment'

const extrato: ExtratoConta = {
    saldoAnterior: 0,
    saldoAtual   : 0,
    totEnt       : 0,
    totSai       : 0,
    extrato      : [],
}

export class ReportExtratoCaixaPDF{

    private dados: ExtratoConta
    private dadosEmpresa: any
    private datai: string = ''
    private dataf: string = ''

    constructor(dados: ExtratoConta, datai: string, dataf: string){
        this.dados = dados
        this.datai = datai
        this.dataf = dataf
    }

    async GerarPDF() {

        this.dadosEmpresa = Funcoes.GetDadosEmpresa()        
    
        pdfMake.vfs = pdfFonts.pdfMake.vfs

        let dados = this.dados.extrato.map( (item: Caixa) => {
            return [
                {text: moment(item.data).format('DD/MM/YYYY'),    aligment: 'left',   fontSize: 8, margin: [0, 2, 0, 2], border: [false, false, false, true]},                
                {text: item.historico,                            aligment: 'left',   fontSize: 8, margin: [0, 2, 0, 2], border: [false, false, false, true]},
                {text: Funcoes.numberFormat(item.valor),          alignment: 'right', fontSize: 8, margin: [0, 2, 0, 2], border: [false, false, false, true]},
                {text: item.tipo === "D" ? "Débito" : 'Crédito',  aligment: 'left',   fontSize: 8, margin: [0, 2, 0, 2], border: [false, false, false, true]},
                {text: Funcoes.numberFormat(item.acumulado || 0), alignment: 'right', fontSize: 8, margin: [0, 2, 0, 2], border: [false, false, false, true]},
            ]
        } )
            
        const footer = (currentPage: number, pageCount: number,) => {
          return [
            {
              layout: 'Borders',
              style: 'tableExample',
              margin: [50, 0, 50, 50],
              table: {
                headerRows: 1,                
                widths: ['*', '*'],
                body: [
                  [
                    { text: 'Emissão: ' + moment(new Date()).format('DD/MM/YYYY HH:mm'), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                    { text: 'Pág. ' + currentPage + '/' + pageCount, alignment: 'right', fontSize: 10, margin: [0, 0, 0, 0], border: [false, true, false, false] },
                  ],
                ]
              }
            },
          ]
        };
    
        const docDefinitions: any = {
          pageSize: 'A4',
          pageMargins: [50, 0, 50, 50],
          content: [    
            {
              layout: 'Borders',
              style: 'tableExample',
              table: {
                headerRows: 1,
                widths: ['*'],
                body: [
                [{ text: this.dadosEmpresa?.fantasia || '', bold: true, alignment: 'center', margin: [0, 2, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                [{ text: 'CNPJ: ' + (Funcoes.FormatDoc(this.dadosEmpresa?.cnpj_cpf) || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                [{ text: (this.dadosEmpresa?.endereco || '') + (this.dadosEmpresa?.numero ? " N." + this.dadosEmpresa?.numero : '') + ' ' + (this.dadosEmpresa?.bairro || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                [{ text: (this.dadosEmpresa?.cidade || '') + " - " + (this.dadosEmpresa?.uf || ''), bold: true, alignment: 'center', margin: [0, 0, 0, 0], fontSize: 13, border: [false, false, false, false] },],
                ],
              },
            },
    
            {              
              layout: 'noBorders',
              style: 'tableExample',
              table: {
                widths: ['100%'],
                body: [
                  [{ text: 'Extrato de caixa', alignment: 'center', fontSize: 15, style: 'header', margin: [0, 1, 0, 1] }],
                ],
    
              },    
            },                
            {
              layout: 'noBorders',
              style: 'tableExample',
              margin: [0, 0, 0, 0],
              table: {                
                body: [
                  [
                    this.datai !== '' ?
                      {
                        text: [                            
                          { text: 'Período: ', fontSize: 10,},
                          { text: moment(this.datai).format("DD/MM/YYYY"), fontSize: 10, bold: true },
                          { text: this.dataf !== '' ? '   à   ' : '', fontSize: 9 },
                          { text: moment(this.dataf).format("DD/MM/YYYY"), fontSize: 10, bold: true}
                        ],
                        margin: [0, 0, 0, 0]
                    } : null,
                    {text: 'Conta: Caixa Geral', fontSize: 10}                    
                  ],
                ],
              },              
            },
            {
                layout: 'noBorders',
                style: 'tableExample',
                margin: [0, 0, 0, 0],
                table: {                
                  body: [
                    [                      
                      {text: `Saldo Anterior: R$ ${Funcoes.numberFormat(this.dados.saldoAnterior)}`, fontSize: 8},
                      {text: `Entradas: R$ ${Funcoes.numberFormat(this.dados.totEnt)} `, fontSize: 8},
                      {text: `Saídas: R$ ${Funcoes.numberFormat(this.dados.totSai)}`, fontSize: 8},
                      {text: `Saldo atual: R$ ${Funcoes.numberFormat(this.dados.saldoAtual)}`, fontSize: 8},
                    ],
                  ],
                },              
              },
            
            {
                layout: 'Borders',
                style: 'tableExample',
                margin: [0, 0, 0, 0],
                table: {
                  widths: [60, 200, '*', '*', '*'],                  
                  body: [
                    [ { text: 'Data', alignment: 'left', fontSize: 8, margin: [0, 4, 0, 4], border: [false, false, false, true], bold: true },                    
                        { text: 'Histórico', alignment: 'left', fontSize: 8, margin: [0, 4, 0, 4], border: [false, false, false, true], bold: true },
                        { text: 'Valor(R$)', alignment: 'right', fontSize: 8, margin: [0, 4, 0, 4], border: [false, false, false, true], bold: true },
                        { text: 'Tipo', alignment: 'left', fontSize: 8, margin: [0, 4, 0, 4], border: [false, false, false, true], bold: true },
                        { text: 'Acumulado(R$)', alignment: 'right', fontSize: 8, margin: [0, 4, 0, 4], border: [false, false, false, true], bold: true },
                    ],
                ],
                },
              },
            
            {
              layout: 'Borders',
              style: 'tableExample',
              margin: [0, 0, 0, 0],
              table: {
                widths: [60, 200, '*', '*', '*'],                
                body: dados
              },
            }
    
          ].filter(Boolean),
    
          footer: footer
        };
    
        pdfMake.createPdf(docDefinitions).print();
    
      }

}